import { basicEpic } from 'redux/ducks/helpers';
import { ConfirmationService } from 'services';
import { RESEND_CONFIRMATION } from './index';

export const resendConfirmation = basicEpic(RESEND_CONFIRMATION, ({ email }, state) =>
  new ConfirmationService(state.session).resend(email)
);
